import {
  Coffee, GlassWater, UtensilsCrossed, Wine, Martini, Film, Drama, Music, Palette, Footprints,
  Sandwich, Umbrella, Bike, Mountain, CircleDot, Flag, Grip, Dumbbell, Flower2, ChefHat, MicVocal,
  Gamepad2, Camera, Sunset, ShoppingBag, FerrisWheel, Sailboat, Ticket, Plus, type LucideIcon,
} from "lucide-react";

// Catalogue figé des activités proposables pour un rendez-vous ("Date") — jumeau exact du
// backend (OLTODO-backend/src/utils/dateActivities.ts, qui valide `activity_key`) et de mobile
// (OLTODO/utils/dateActivities.ts, mêmes clés). Les libellés viennent du système i18n
// (clé `date_activity_<key>`), jamais codés en dur ici.
export interface DateActivity {
  key: string;
  i18nKey: string;
  Icon: LucideIcon;
}

export const DATE_ACTIVITIES: DateActivity[] = [
  { key: "cafe", i18nKey: "date_activity_cafe", Icon: Coffee },
  { key: "drink", i18nKey: "date_activity_drink", Icon: GlassWater },
  { key: "restaurant", i18nKey: "date_activity_restaurant", Icon: UtensilsCrossed },
  { key: "wine_bar", i18nKey: "date_activity_wine_bar", Icon: Wine },
  { key: "cocktails", i18nKey: "date_activity_cocktails", Icon: Martini },
  { key: "cinema", i18nKey: "date_activity_cinema", Icon: Film },
  { key: "show", i18nKey: "date_activity_show", Icon: Drama },
  { key: "concert", i18nKey: "date_activity_concert", Icon: Music },
  { key: "museum", i18nKey: "date_activity_museum", Icon: Palette },
  { key: "walk", i18nKey: "date_activity_walk", Icon: Footprints },
  { key: "picnic", i18nKey: "date_activity_picnic", Icon: Sandwich },
  { key: "beach", i18nKey: "date_activity_beach", Icon: Umbrella },
  { key: "bike", i18nKey: "date_activity_bike", Icon: Bike },
  { key: "hike", i18nKey: "date_activity_hike", Icon: Mountain },
  { key: "bowling", i18nKey: "date_activity_bowling", Icon: CircleDot },
  { key: "mini_golf", i18nKey: "date_activity_mini_golf", Icon: Flag },
  { key: "climbing", i18nKey: "date_activity_climbing", Icon: Grip },
  { key: "sport", i18nKey: "date_activity_sport", Icon: Dumbbell },
  { key: "wellness", i18nKey: "date_activity_wellness", Icon: Flower2 },
  { key: "cooking_class", i18nKey: "date_activity_cooking_class", Icon: ChefHat },
  { key: "karaoke", i18nKey: "date_activity_karaoke", Icon: MicVocal },
  { key: "arcade", i18nKey: "date_activity_arcade", Icon: Gamepad2 },
  { key: "photo_walk", i18nKey: "date_activity_photo_walk", Icon: Camera },
  { key: "sunset", i18nKey: "date_activity_sunset", Icon: Sunset },
  { key: "shopping", i18nKey: "date_activity_shopping", Icon: ShoppingBag },
  { key: "amusement_park", i18nKey: "date_activity_amusement_park", Icon: FerrisWheel },
  { key: "boat", i18nKey: "date_activity_boat", Icon: Sailboat },
  { key: "event", i18nKey: "date_activity_event", Icon: Ticket },
  { key: "other", i18nKey: "date_activity_other", Icon: Plus },
];

export const dateActivityByKey = (key: string): DateActivity | undefined =>
  DATE_ACTIVITIES.find(a => a.key === key);
